import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

function load() {
  try { const v = JSON.parse(localStorage.getItem("bpj_cart") || "[]"); return Array.isArray(v) ? v : []; }
  catch { return []; }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);
  useEffect(() => { localStorage.setItem("bpj_cart", JSON.stringify(items)); }, [items]);

  const add = (product) => {
    setItems((prev) => {
      const f = prev.find((i) => i.id === product.id);
      if (f) return prev.map((i) => (i.id === product.id ? { ...i, qty: Math.min(i.qty + 1, 20) } : i));
      return [...prev, { id: product.id, name: product.name, price: product.price, image: product.image, qty: 1 }];
    });
    setOpen(true);
  };
  const setQty = (id, qty) => setItems((p) => (qty < 1 ? p.filter((i) => i.id !== id) : p.map((i) => (i.id === id ? { ...i, qty: Math.min(qty, 20) } : i))));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.qty * i.price, 0);

  return <CartCtx.Provider value={{ items, add, setQty, clear, count, total, open, setOpen }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
